import { normalizeHexColor } from '@dealerportal/utilities';

export function resolveChatColor(
  colorMode: string | undefined,
  customColor: string | undefined,
  themedColor: string | undefined,
  ctaColor: string | undefined
): string {
  const fallbackColor = normalizeHexColor(ctaColor) ?? '#2563eb';
  const normalizedCustomColor = normalizeHexColor(customColor);

  if (colorMode === 'custom' && normalizedCustomColor) {
    return normalizedCustomColor;
  }

  if (colorMode === 'custom' || colorMode === 'Default') {
    return fallbackColor;
  }

  return normalizeHexColor(themedColor) ?? fallbackColor;
}
